import solscan from '../assets/explorer/solscan.webp'
import solanaExplorer from '../assets/explorer/solana_explorer.webp'
import magicEden from '../assets/explorer/magic_eden.webp'

interface ExplorerIconProps {
    mint: string
    baseURL: string
    iconURL: string
    title?: string
    style?: React.CSSProperties
}

function ExplorerIcon({ mint, baseURL, iconURL, title, style }: ExplorerIconProps) {
    const url = `${baseURL}${mint}`
    return (
        <a
            href={url}
            target='_blank'
            rel='noopener noreferrer'
            title={title}
            className='block h-[1em] w-[1em]'
            style={style}
        >
            <img src={iconURL} alt='Explorer Icon' className='w-full h-full object-contain' />
        </a>
    )
}

function Solscan({ mint }: { mint: string }) {
    return (
        <ExplorerIcon
            mint={mint}
            baseURL='https://solscan.io/token/'
            iconURL={solscan}
            title='Solscan'
            style={{ scale: '0.9' }}
        />
    )
}

function SolanaExplorer({ mint }: { mint: string }) {
    return (
        <ExplorerIcon
            mint={mint}
            baseURL='https://explorer.solana.com/address/'
            iconURL={solanaExplorer}
            title='Solana Explorer'
            style={{ mixBlendMode: 'hard-light' }}
        />
    )
}

function MagicEden({ mint }: { mint: string }) {
    return (
        <ExplorerIcon
            mint={mint}
            baseURL='https://magiceden.io/item-details/'
            iconURL={magicEden}
            title='Magic Eden'
            style={{ scale: '1.5' }}
        />
    )
}

ExplorerIcon.Solscan = Solscan
ExplorerIcon.SolanaExplorer = SolanaExplorer
ExplorerIcon.MagicEden = MagicEden

export { ExplorerIcon }
